import { render } from "./CarPage.vue?vue&type=template&id=047b82bc&scoped=true"
import script from "./CarPage.vue?vue&type=script&lang=js"
export * from "./CarPage.vue?vue&type=script&lang=js"

import "./CarPage.vue?vue&type=style&index=0&id=047b82bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047b82bc"]])

export default __exports__